/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-children-prop */
/* eslint-disable no-tabs */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import DocumentationDropdown from "shared-components/lib/documentation/documentation_dropdown";
import ExportLink from "shared-components/lib/documentation/export_link";

import { selectEventsData } from "../../../store/slices/common";
import useCheckMobileScreen from "../../../utils/useCheckMobileScreen";
import { getCurrentConfiguration } from "../../../utils/api/common";
import { logEvent } from "../../../utils/api/api";
import t from "../../../utils/translation/translator";

import { setShowEmailPopup, showSnackbar } from "../../../../Retrofit/store/slices/retrofit";

const ActionSharing = ({ ...props }) => {
  const configuration = getCurrentConfiguration();
  const eventsData = useSelector(selectEventsData);
  const dispatch = useDispatch();

  const locale = window.msizerConfiguration?.locale || "en-WW";
  const splitLocale = locale.split("-");
  const country = splitLocale[1];

  const isMobile = useCheckMobileScreen();

  const handleCopyConfigId = () => {
    navigator.clipboard.writeText(configuration.configId);

    dispatch(
      showSnackbar({
        id: "CONFIGURATION_ID_COPIED"
      })
    );
    logEvent(eventsData.locale, eventsData.types.copyConfId, eventsData.tags.none, configuration?.configId);
  };

  const exportSharing = [];

  exportSharing.push(
    <>
      <ExportLink
        key="copy_to_clipboard"
        name={t("msizer.ui.copy_configuration_id", { id: configuration.configId || "" })}
        onDownload={() => handleCopyConfigId()}
        icon="pages-double"
      />
      {country !== "CN" && (
        <ExportLink
          key="send_by_email"
          name={t("msizer.ui.send_configuration_by_mail")}
          onDownload={() => dispatch(setShowEmailPopup(true))}
          icon="envelope-motion-lines"
        />
      )}
    </>
  );

  return (
    <div className="ActionSharing" {...props}>
      <DocumentationDropdown title={t("msizer.ui.share")} children={exportSharing} defaultOpenStatus={!isMobile} />
    </div>
  );
};

export default ActionSharing;
